export const types = {
  // Sync
  SHOW_REQUEST_ERROR_MODAL: "SHOW_REQUEST_ERROR_MODAL",
  HIDE_REQUEST_ERROR_MODAL: "HIDE_REQUEST_ERROR_MODAL",
};
